import Confirm from 'semantic-ui-react/dist/commonjs/addons/Confirm';
import '@purple/semantic-ui-purple-theme/components/button.css';
import '@purple/semantic-ui-purple-theme/components/modal.css';

export default Confirm;
